var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStakeholders = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 30,
    height: 30,
    rx: 6,
    fill: "#1B5482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 9.25,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 10,
    r: 2.25,
    fill: "#1B5482",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21.25C26.7574 21.25 25.75 20.2426 25.75 19C25.75 17.7574 26.7574 16.75 28 16.75C29.2426 16.75 30.25 17.7574 30.25 19C30.25 20.2426 29.2426 21.25 28 21.25Z",
    fill: "#1B5482",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 28,
    r: 2.25,
    fill: "#1B5482",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21.25C8.75736 21.25 7.75 20.2426 7.75 19C7.75 17.7574 8.75736 16.75 10 16.75C11.2426 16.75 12.25 17.7574 12.25 19C12.25 20.2426 11.2426 21.25 10 21.25Z",
    fill: "#1B5482",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStakeholders, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stakeholders.72cf9d5f.svg";
export { ForwardRef as ReactComponent };